import React from 'react';
import Navbar from './components/Navbar';
import Landing from './components/Landing';
import Boxtxt from './components/Boxtxt';
import HealthSection from './components/HealthSection';
import VideoSection from './components/VideoSection';
import ExperienceSection from './components/ExperienceSection';
import Newsec from './components/Newsec';
import CoreProgrammesSection from './components/CoreProgrammesSection';
import ChenotProductsSection from './components/ChenotProductsSection';
import Formtxt from './components/Formtxt';
import Royaltxt from './components/Royaltxt';
import FooterSection from "./components/FooterSection";

function App() {
  return (
    <div className="bg-white text-gray-900">
      <Navbar />
      <Landing />
      <Boxtxt />
      <VideoSection />
      <Royaltxt />
      <ExperienceSection />
      <Newsec />
      <CoreProgrammesSection />
      <ChenotProductsSection />
      <Formtxt />
      <HealthSection />
      <FooterSection />
    </div>
  );
}

export default App;
